import { Document, Page, Text, View } from '@react-pdf/renderer';
import { Table, TableTimeLog } from './Table';
import { Header } from './Header';
import { Diagram, IDiagramProps } from './Diagram';
import { pageStyle } from './style';
import { headerStyle } from './Header/style';

export interface BaseUserOnProject {
    projectName: string;
    memberName: string;
    memberLastName: string;
}

interface IUserOnProject extends BaseUserOnProject {
    timeLogs: TableTimeLog[];
    totalTime: string;
    clientName: string;
    period: string;
    diagramProps: IDiagramProps;
    hasUnsubmittedLogs: boolean;
}

export const UserOnProject = ({
    projectName,
    memberName,
    memberLastName,
    timeLogs,
    totalTime,
    clientName,
    period,
    diagramProps,
    hasUnsubmittedLogs,
}: IUserOnProject) => {
    return (
        <Document>
            <Page style={pageStyle.page}>
                <Header clientName={clientName} memberLastName={memberLastName} memberName={memberName} period={period} projectName={projectName} />

                {hasUnsubmittedLogs && (
                    <View>
                        <Text style={headerStyle.unofficialTimeSheet}>THIS IS NOT THE OFFICIAL VERSION OF TIMESHEET.</Text>
                    </View>
                )}

                <Diagram {...diagramProps} />
                <Table memberLastName={memberLastName} memberName={memberName} projectName={projectName} timeLogs={timeLogs} totalTime={totalTime} />
            </Page>
        </Document>
    );
};
